export default "__VITE_ASSET__C0KN3DG___"